import { takeLatest } from 'redux-saga/effects'

import { beingSignInSaga } from './sagas/begin-sign-in.saga'
import { actionTypes } from './actions'

export function* firebaseWatchSagas() {
  yield takeLatest(actionTypes.BEGIN_SIGN_IN, beingSignInSaga)
}
